import React, {Proptype, Component} from 'react'
import classnames from 'classnames'
import {browserHistory} from 'react-router'

import Permissions from './Permissions';
import __R from 'containers/__R';
import locale from './locale';

import {
  Button,
	PanelWrapper,
	Tabs,
	TabPanel
} from 'components/UI'

class SchoolSettings extends Component {
  constructor(props){
    super(props)
  }

  render(){
    return (
      <PanelWrapper>
        <div>
          {__("Permissions", locale)}
        </div>
            <Permissions />
      </PanelWrapper>
    )
  }
}


export default(SchoolSettings)



// WEBPACK FOOTER //
// ./src/containers/pages/SchoolSettings/index.js